export default __webpack_public_path__ + "static/media/bg-img4.12a1de18.jpg";